/* Dynamically adjust select element width on load and on change */

const selectElement = document.querySelector(".sort-by-button");

function adjustSelectWidth(selectElement) {
  if (!selectElement) {
    return;
  }

  const tempSpan = document.createElement("span");
  tempSpan.style.visibility = "hidden";
  tempSpan.style.whiteSpace = "nowrap";
  document.body.appendChild(tempSpan);

  tempSpan.textContent = selectElement?.options[selectElement?.selectedIndex]?.text;

  const computedWidth = tempSpan.offsetWidth;

  selectElement.style.width = computedWidth + 30 + "px";

  document.body.removeChild(tempSpan);
}

document.addEventListener("DOMContentLoaded", () => adjustSelectWidth(selectElement));
selectElement?.addEventListener("change", () => adjustSelectWidth(selectElement));
